import { AspectRatio, Box, Flex, Stack } from '@chakra-ui/react'
import { motion } from 'framer-motion'

export const MotionBox = motion(Box)
export const MotionAspectRatio = motion(AspectRatio)
export const MotionStack = motion(Stack)
export const MotionFlex = motion(Flex)
